import { Vegobjekt } from '@/domain/vegobjekter/Vegobjekt';
import { statePreferences } from '@/selectors/selectors';
import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { ConfigAndDataContext } from '@/state/context/ConfigAndDataContext';
import { ApiVersion } from '@/state';
import { getApiURLVegobjekter, getApiVersion } from '@/utils/Utils';

type MetadataProps = {
    vegobjekt: Vegobjekt;
};

function Metadata({ vegobjekt }: MetadataProps) {
    const preferences = useSelector(statePreferences);

    const config = useContext(ConfigAndDataContext).config;
    const vegobjekt_base_url = getApiURLVegobjekter(config);
    const vegobjekt_href =
        vegobjekt_base_url +
        '/vegobjekter/' +
        vegobjekt.metadata?.type?.id +
        '/' +
        vegobjekt.id;
    const visibleStedfestinger = 3;

    const [showAllStedfestinger, setShowAllStedfestinger] = useState(false);

    return preferences.showMetadata ? (
        <>
            <hr />
            <h4 className="c-valgt-features__subheader">Metadata</h4>
            {vegobjekt.lokasjon.stedfestinger && [
                <dt key="features__dt-p" className="c-valgt-features__dt">
                    Stedfestinger:
                </dt>,
                <dd key="stedfestinger-dd" className="c-valgt-features__dd">
                    <ul>
                        {(showAllStedfestinger
                            ? vegobjekt.lokasjon.stedfestinger
                            : vegobjekt.lokasjon.stedfestinger.slice(0, 3)
                        ).map(sf => (
                            <li key={sf.kortform} className="c-valgt-features__dd">
                                {(sf.kortform + ' ')
                                    .concat(sf.retning ? sf.retning + ' ' : '')
                                    .concat(sf.sideposisjon ? sf.sideposisjon + ' ' : '')
                                    .concat(
                                        sf.kjørefelt?.length
                                            ? '(' + sf.kjørefelt.join('#') + ')'
                                            : ''
                                    )}
                            </li>
                        ))}
                    </ul>
                    {vegobjekt.lokasjon.stedfestinger.length > visibleStedfestinger && (
                        <button
                            type="button"
                            onClick={() => setShowAllStedfestinger(prev => !prev)}
                            className="o-expand-button"
                            style={{ marginTop: '5px' }}
                            aria-label="Utvid eller minimer visning av stedfestinger"
                            title={
                                showAllStedfestinger
                                    ? 'Minimer visning av stedfestinger'
                                    : 'Utvid visning av stedfestinger'
                            }
                        >
                            {showAllStedfestinger
                                ? 'Vis færre'
                                : `Vis alle (${
                                      vegobjekt.lokasjon.stedfestinger.length -
                                      visibleStedfestinger
                                  })`}
                        </button>
                    )}
                </dd>,
            ]}
            {vegobjekt?.metadata?.startdato && [
                <dt
                    key={'startdate-header_' + vegobjekt.id}
                    className="c-valgt-features__dt"
                >
                    Startdato:
                </dt>,
                <dd
                    key={'startdate-value_' + vegobjekt.id}
                    className="c-valgt-features__dd c-valgt-features-dd"
                >
                    {vegobjekt.metadata.startdato}
                </dd>,
            ]}
            {vegobjekt?.metadata?.sluttdato && [
                <dt
                    key={'enddate-header_' + vegobjekt.id}
                    className="c-valgt-features__dt"
                >
                    Sluttdato:
                </dt>,
                <dd
                    key={'enddate-value_' + vegobjekt.id}
                    className="c-valgt-features__dd c-valgt-features-dd"
                >
                    {vegobjekt.metadata.sluttdato}
                </dd>,
            ]}
            <dt className="c-valgt-features__dt">Objektid:</dt>
            <dd className="c-valgt-features__dd">
                <a
                    href={vegobjekt_href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-description="Åpne vegobjekt i api"
                >
                    {vegobjekt.id}
                </a>
            </dd>
        </>
    ) : null;
}

export default Metadata;
